// Copyright (C) 2020-2023 Berkadia Commercial Mortgage, LLC - All Rights Reserved
import React from 'react'

const myContext = React.createContext({})

export const ThingsProvider = myContext.Provider

export default myContext
